import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Auto-pay setting for automatic credit card charges.
 */
export const schema = z.boolean();

export type AutoPay = z.infer<typeof schema>;

export const definition = define({
  key: 'auto_pay',
  kind: DEFINITION_KINDS.SETTING,
  schema,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  label: 'Auto Pay',
  description:
    "Activate/Deactivate auto-pay for this client. Auto-pay determines whether or not we automatically charge the client's credit card after an invoice closes.",
  category: CATEGORIES.BILLING.key,
  defaultValue: false,

  storage: {
    levels: {
      customer: {
        type: 'dedicated_column',
        table: 'customers',
        column: 'auto_pay',
        valueType: 'Boolean',
      },
    },
  },
});
